export function BottomIfor(props) {
  return (
    <div className="bottom-information">
      <div className="center-box">
        <div className="bottom-info-left">
          <div className="bottom-info-lineone">
            <div className="lineonelogo"></div>
            <div className="lingright">
              <div className="social-list">
                <a
                  href="https://www.cctalk.com/m/group/82776894"
                  rel="noreferrer"
                  target="_blank"
                >
                  <div className="social-icon-cc"></div>
                </a>
                <a
                  href="https://space.bilibili.com/181578039"
                  rel="noreferrer"
                  target="_blank"
                >
                  <div className="social-icon-bilibili"></div>
                </a>
                <a
                  href="https://www.weibo.com/u/1926245291"
                  rel="noreferrer"
                  target="_blank"
                >
                  <div className="social-icon-weibo"></div>
                </a>
                <a
                  href="https://www.zhihu.com/org/kkmo-fa-xue-yuan"
                  rel="noreferrer"
                  target="_blank"
                >
                  {" "}
                  <div className="social-icon-zhihu"></div>
                </a>
                {/* <a href="https://www.artstation.com/krenz" rel="noreferrer" target="_blank"><div className="social-icon-art"></div></a> */}
              </div>
            </div>
          </div>
          <div className="bottom-info-linetwo">
            <div>
              KRENZ'S ARTWORK
              拥有业界十余年丰富教学经验，深入浅出的独创授课方式获得同学青睐
            </div>
            <div>
              <div>
                KRENZ'S ARTWORK WITH MORE THAN TEN YEARS OF TEACHING EXPERIENCE
                IN THE INDUSTRY,
              </div>
              <div>
                THE ORIGINAL TEACHING METHOD IN SIMPLE LANGUAGE IS FAVORED BY
                STUDENTS
              </div>
            </div>
          </div>
          <div className="bottom-info-linethree">
            <div className="edition">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/recordQuery"
                style={{ color: "#979797" }}
              >
                沪ICP备20009980号-1
              </a>
              <span>COPYRIGHT </span>
              <span>© </span>
              <span>2025 </span>
              <span>厚薄 </span>
              <span>ALL </span>
              <span>RIGHTS </span>
              <span> RESERVED</span>
            </div>
          </div>
        </div>
        <div className="bottom-info-devide"></div>
        <div className="bottom-info-right">
          <div className="contactus">联系我们</div>
          <div className="bdQQ">商务合作邮箱：crystalli963@163.com</div>
          <div className="erweicode"></div>
          <div className="subscription">Krenz绘画教室</div>
        </div>
      </div>
    </div>
  );
}
